import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import NavLink from 'client/components/aria/NavLink/NavLink';

import { CONTACT_PAGE_SIGNED_OUT } from 'client/utils/routes/routeConstants';
import { loginRedirect } from 'client/utils/auth/msalHelpers';
import Link from 'client/components/aria/Link/Link';
import { serviceDeskEmail, serviceDeskTelephone } from 'client/utils/constants/frontEndConfig';
import { USER_PROFILE_NOT_FOUND } from 'client/utils/constants/errors';

const ErrorMessage = ({ code, service, message, redirect, id }) => {
    const intl = useIntl();

    if (message && code === 404 && message === USER_PROFILE_NOT_FOUND.message) {
        code = USER_PROFILE_NOT_FOUND.code;
        message = null;
    }

    if (!id) {
        id = `errorPage.${code}`;
    };

    return <FormattedMessage id={id} values={{
        h1: chunks => <h1 className="govuk-heading-l">{chunks}</h1>,
        service: chunks => service || chunks,
        p: chunks => <p className="govuk-body">{chunks}</p>,
        message: () => message ? <p className="govuk-body govuk-!-font-weight-bold">{message}</p> : null,
        redirect: chunks => <NavLink
            to={redirect}
            aria-label={intl.formatMessage({ id: 'errorPage.redirect' })}
            rel="noreferrer"
        >
            {chunks}
        </NavLink>,
        serviceDesk: chunks => <NavLink
            to={CONTACT_PAGE_SIGNED_OUT}
            aria-label={intl.formatMessage({ id: 'errorPage.serviceDesk' })}
            rel="noreferrer"
        >
            {chunks}
        </NavLink>,
        login: chunks => <NavLink to='#' onPress={() => { loginRedirect(); }}>{chunks}</NavLink>,
        serviceEmail: () => <Link className={'govuk-link'}
            href={`mailto:${serviceDeskEmail}`}>{serviceDeskEmail}</Link>,
        servicePhone: () => <Link className={'govuk-link'}
            href={`tel:${serviceDeskTelephone}`}>{serviceDeskTelephone}</Link>
    }}/>;
};

ErrorMessage.propTypes = {
    code: PropTypes.oneOf([503, 500, 400, 401, 403, 404, 408, 429]),
    service: PropTypes.string,
    message: PropTypes.string,
    redirect: PropTypes.string,
    id: PropTypes.string
};

ErrorMessage.defaultProps = {
    code: 404
};

export default ErrorMessage;
